<script lang="ts">
    export let class_list = [];
    export const focus = ()=>{inner_htmlelement.scrollIntoView({behavior:"smooth",block:"nearest"})}
    let inner_htmlelement: HTMLDivElement;
</script>

<div bind:this="{inner_htmlelement}" on:click class="card-panel {class_list.join(" ")}">
    <slot></slot>
</div>


<style>
    .highlight_panel {
        box-shadow: 0px 0px 16px 2px #1b5186;
    }
</style>